export const isRelativePath = (raw) => /^\//.test(raw)

export const getQualifiedURLOrPath = (raw, options = {}) => {
  const { patchProtocol = "http" } = options
  // If this, raw is already a fully qualified URL like "http://something"
  if (/^(https?:\/\/|tel:)/.test(raw)) {
    return raw
  }
  // If this, raw is a domain-relative path like "/hello"
  if (isRelativePath(raw)) {
    return raw
  }
  // Otherwise, we assume raw is missing a protocol, like "google.com"
  return `${patchProtocol}://${raw}`
}
